import { normalizeWorkshopRoleType, WORKSHOP_OPERATOR_PHASE_NAME_HINTS } from './workshopOperatorView';

const DONE_STATUSES = new Set(['completed']);
const CONCEPTION_DONE_STATUSES = new Set(['submitted', 'completed']);

export const WORKSHOP_QUEUE_PREVIOUS_ROLE = {
  operator_thermo: 'operator_3d',
  operator_finition: 'operator_thermo',
  livraison: 'operator_finition',
};

export function isWorkshopQueueStationRole(roleType) {
  const role = normalizeWorkshopRoleType(roleType) || roleType;
  return role === 'operator_3d' ||
    Object.prototype.hasOwnProperty.call(WORKSHOP_QUEUE_PREVIOUS_ROLE, role);
}

function normalizeText(value) {
  return String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

function getBatchPhases(batch) {
  return batch?.caseTimelinePhases || batch?.case?.case_timeline_phases || [];
}

function getPhasesForLot(batch) {
  const phases = getBatchPhases(batch);
  const group = batch?.group ?? batch?.current_phase;
  if (group == null || group === '') return phases;

  return phases.filter((phase) => String(phase?.group) === String(group));
}

export function isPhaseDone(phase) {
  return Boolean(phase && DONE_STATUSES.has(phase.status));
}

export function phaseMatchesWorkshopRole(phase, roleType) {
  const role = normalizeWorkshopRoleType(roleType) || roleType;
  const hints = WORKSHOP_OPERATOR_PHASE_NAME_HINTS[role] || [];
  const name = normalizeText(phase?.phase_name || phase?.name);
  return Boolean(name && hints.some((hint) => name.includes(normalizeText(hint))));
}

export function findWorkshopPhase(phases, roleType) {
  return (phases || [])
    .filter((phase) => phaseMatchesWorkshopRole(phase, roleType))
    .sort((a, b) => (a.phase_order ?? 0) - (b.phase_order ?? 0))[0] || null;
}

export function isConceptionValidated(phases) {
  const list = Array.isArray(phases) ? phases : [];
  const namedConception = list.filter((phase) => {
    const name = normalizeText(phase?.phase_name || phase?.name);
    return name.includes('conception') || name.includes('design');
  });
  const candidates = namedConception.length > 0
    ? namedConception
    : list.filter(
        (phase) => String(phase?.group) === '1' && Number(phase?.phase_order) < 4
      );

  return candidates.some((phase) => CONCEPTION_DONE_STATUSES.has(phase?.status));
}

export function isLotReadyForStation(batch, roleType) {
  const role = normalizeWorkshopRoleType(roleType) || roleType;
  if (!isWorkshopQueueStationRole(role)) return false;

  const phases = getPhasesForLot(batch);
  const currentPhase = findWorkshopPhase(phases, role);
  if (!currentPhase || isPhaseDone(currentPhase)) return false;

  if (role === 'operator_3d') {
    return isConceptionValidated(phases);
  }

  const previousPhase = findWorkshopPhase(
    phases,
    WORKSHOP_QUEUE_PREVIOUS_ROLE[role]
  );
  return isPhaseDone(previousPhase);
}
